import {omit} from 'underscore';

import RideScheduleStop from 'common/types/RideScheduleStop';

export default class RideSchedule {
  constructor({
      dropoff = null,
      pickup = null,
      vehicle = null,
  }) {
    this.dropoff = dropoff ? new RideScheduleStop(dropoff) : null;
    this.pickup = pickup ? new RideScheduleStop(pickup) : null;
    this.vehicle = vehicle
      ? {
        vehicleId: vehicle.vehicle_id,
        callName: vehicle.call_name,
      }
      : null;
  }

  clone() {
    return new RideSchedule(this.serialize());
  }

  serialize() {
    return omit({
      dropoff: this.dropoff.serialize(),
      pickup: this.pickup.serialize(),
      vehicle: this.vehicle
        ? {
          vehicle_id: this.vehicle.vehicleId,
          call_name: this.vehicle.callName,
        }
        : null,
    }, value => value === null);
  }
}



// WEBPACK FOOTER //
// ./src/common/types/RideSchedule.js